"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;

var _index = _interopRequireDefault(require("../lib/index.js"));

/**
 * Interface for creating radio elements. Note: this code is also used by React Native to set the type
 * of the Form Element component.
 *
 * @displayName Radio
 * @class Radio
 * @public
 */
class Radio extends _index.default {
  constructor() {
    super(...arguments);
    this.type = 'radio';
    this.isFlip = true;
  }

  render() {
    return super.render();
  }

}

exports.Radio = Radio;
var _default = Radio;
exports.default = _default;